import type { ComponentPropsWithoutRef } from 'react';

import clsx from 'clsx';

type ShiningPropsType = ComponentPropsWithoutRef<'div'>;

const Shining = ({ className, ...restProps }: ShiningPropsType) => (
    <div className={clsx('shining', className)} {...restProps} />
);

export default Shining;
